// data/calls/operator/fetchAdmin.ts
import apiCall from "../../axios";
import { ILocationDetailsGetResult } from "@/data/interfaces/admin";
import { ICamera } from "@/data/interfaces/camera";

export interface IAdminDataResponse {
    activeUserCountsByLocation: { [key: string]: number };
    locationsByTier: { tier: number; locations: ILocationDetailsGetResult[] }[];
    queueIsPaused: boolean;
    snoozedCams: ICamera[];
}

export const fetchAdmin = async (): Promise<IAdminDataResponse> => {
    let tail = `operator/admin`;
    const res = await apiCall<{ data: IAdminDataResponse }>("GET", tail);
    return res.data;
};

export default fetchAdmin;